import { render, staticRenderFns } from "./car-plate-keyboard.vue?vue&type=template&id=7cdc5c1e&scoped=true"
import script from "./car-plate-keyboard.vue?vue&type=script&lang=js"
export * from "./car-plate-keyboard.vue?vue&type=script&lang=js"
import style0 from "./car-plate-keyboard.vue?vue&type=style&index=0&id=7cdc5c1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc5c1e",
  null
  
)

export default component.exports